import { Sparkles, Twitter, Linkedin, Github, Mail } from "lucide-react";

const cols = [
  { title: "Product", links: ["What it does", "Candidate Discovery", "AI Intelligence", "Recruit Faster"] },
  { title: "Company", links: ["About", "Founding Program", "Careers", "Contact"] },
  { title: "Resources", links: ["Blog", "Documentation", "Changelog", "Status"] },
  { title: "Legal", links: ["Privacy", "Terms", "Security", "DPA"] },
];

const socials = [
  { i: Twitter, label: "Twitter", href: "#" },
  { i: Linkedin, label: "LinkedIn", href: "#" },
  { i: Github, label: "GitHub", href: "#" },
  { i: Mail, label: "Email", href: "mailto:hello@kyvelra.com" },
];

export const Footer = () => (
  <footer className="border-t border-navy-800 bg-navy-950 pt-20 pb-10" data-testid="footer">
    <div className="mx-auto max-w-7xl px-6">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr_1fr]">
        <div>
          <a href="#top" className="flex items-center gap-2">
            <span className="grid h-8 w-8 place-items-center rounded-lg bg-electric text-white">
              <Sparkles className="h-4 w-4" />
            </span>
            <span className="font-serif text-xl text-white">Kyvelra</span>
          </a>
          <p className="mt-5 max-w-xs font-body text-sm leading-relaxed text-electric-ice/50">
            AI-powered candidate discovery built for modern recruiters and
            staffing firms.
          </p>
          <div className="mt-6 flex gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                data-testid={`social-${s.label.toLowerCase()}`}
                className="grid h-10 w-10 place-items-center rounded-full border border-navy-700 text-electric-ice/60 transition-colors duration-300 hover:border-electric hover:text-white"
              >
                <s.i className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        {cols.map((c) => (
          <div key={c.title}>
            <h4 className="eyebrow text-electric-ice/40">{c.title}</h4>
            <ul className="mt-5 space-y-3">
              {c.links.map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    className="font-display text-sm text-electric-ice/65 transition-colors duration-300 hover:text-white"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-navy-800 pt-8 sm:flex-row">
        <p className="font-display text-xs text-electric-ice/40">
          © {new Date().getFullYear()} Kyvelra. All rights reserved.
        </p>
        <p className="font-display text-xs text-electric-ice/40">
          Recruit Smarter. Discover Faster.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
